import React from 'react';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import Button from 'reactstrap/lib/Button';
import {
  getCoreUrl,
  getFeaturesSpecsUrlStandard,
  getCustomCoreUrl,
} from 'client/site-modules/shared/utils/core-link-constructor';
import { generateSrpLinkNewMakeModel } from 'client/site-modules/shared/utils/srp-link-constructor';
import { getBuildAndPriceLink } from 'site-modules/shared/utils/build-and-price-link-constructor';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { PhotoflipperButtonAsync } from 'site-modules/shared/components/photoflipper-core/photoflipper-button/photoflipper-button-async';
import { Link } from 'site-modules/shared/components/link/link';
import './shopping-tools.scss';

export function ShoppingTools({ makeModelSubmodelYear }) {
  const {
    make: { slug: makeSlug },
    model: { slug: modelSlug },
    year,
  } = makeModelSubmodelYear;
  const makeModelYear = { makeSlug, modelSlug, year };

  const linksList = [
    {
      href: getCoreUrl(makeModelYear),
      name: 'Review',
    },
    {
      href: generateSrpLinkNewMakeModel(makeSlug, modelSlug),
      name: 'For sale',
    },
    {
      href: getBuildAndPriceLink({ make: makeSlug, model: modelSlug, year }),
      name: 'Pricing',
    },
    {
      href: getFeaturesSpecsUrlStandard(makeModelYear),
      name: 'Features',
    },
    {
      component: (
        <PhotoflipperButtonAsync makeSlug={makeSlug} modelSlug={modelSlug} year={year}>
          <Button
            color="link"
            size="lg"
            className="photoflipper-btn text-primary-darker text-transform-none p-0 border-0"
          >
            Photos
          </Button>
        </PhotoflipperButtonAsync>
      ),
      name: 'Photos',
    },
    {
      href: getCustomCoreUrl(makeModelYear, 'consumer-reviews/'),
      name: 'Consumer reviews',
    },
    {
      href: getCustomCoreUrl(makeModelYear, 'mpg/'),
      name: 'MPG',
    },
    {
      href: getCustomCoreUrl(makeModelYear, 'cost-to-own/'),
      name: 'Ownership costs',
    },
    {
      href: '/car-comparisons/',
      rel: 'nofollow',
      name: 'Compare cars',
    },
  ].filter(({ hide }) => !hide);

  return (
    <section className="shopping-tools" data-tracking-parent="shopping_tools">
      <h2 className="heading-3 mb-1">Shopping tools</h2>
      <Row tag="ul" className="px-0_5 text-primary-darker list-unstyled mb-0">
        <Col xs={7} tag="li" className="ps-0 mb-0_75 text-gray-darker">
          Incentives and rebates
        </Col>
        {linksList.map(({ href, rel, name, component }, index) => (
          <Col tag="li" xs={index % 2 ? 7 : 5} className="mb-0_75 ps-0" key={name}>
            {component || (
              <Link to={href} rel={rel} data-tracking-id="view_content">
                {name}
              </Link>
            )}
          </Col>
        ))}
      </Row>
    </section>
  );
}

ShoppingTools.propTypes = {
  makeModelSubmodelYear: VehicleEntities.MakeModelSubmodelYear.isRequired,
};
